import { XMarkIcon } from '@heroicons/react/20/solid';
import { FC, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';

import { appSettings } from '@/settings/app-settings';
import { VideoPlayer } from '@/ux-legacy/components/common/VideoPlayer/VideoPlayer';

type VideoContentProps = {
  src: string;
};

const VideoContent: FC<VideoContentProps> = ({ src }) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const video = useMemo(() => {
    return (
      <VideoPlayer
        className="w-full h-full object-cover"
        autoPlay={true}
        controls={false}
        loop={true}
        muted={true}
        playsInline={true}
        source={appSettings.api.VIDEO_URL + src}
      />
    );
  }, [src]);

  return (
    <>
      {src && (
        <div className="w-full h-full">
          <button
            className="w-full h-full flex justify-center items-center group"
            onClick={() => setIsExpanded(true)}
          >
            {video}
          </button>
          {isExpanded &&
            createPortal(
              <div className="fixed top-0 left-0 z-[9999] w-full h-full flex justify-center items-center bg-slate-800/90 cursor-pointer">
                <XMarkIcon
                  className="absolute top-2 right-2 z-[99] h-10 w-10 text-white bg-slate-800 rounded-full"
                  onClick={() => setIsExpanded(false)}
                />
                <VideoPlayer
                  className="max-w-[90dvw] max-h-[90dvh] object-cover rounded-lg md:rounded-xl mt-4"
                  autoPlay={false}
                  controls={true}
                  loop={false}
                  muted={true}
                  playsInline={true}
                  source={appSettings.api.VIDEO_URL + src}
                />
              </div>,
              document.body,
            )}
        </div>
      )}
    </>
  );
};

export default VideoContent;
